import React from "react";

import { Card, //Button
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
//import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
//import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  ticketHeader: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    padding: theme.spacing(0.5, 2),
    backgroundColor: theme.palette.background.default,
    flex: "none",
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0.5, 1),
    },
  },
}));

const TicketHeader = ({ loading, children }) => {
  const classes = useStyles();
  /*const history = useHistory();
  const handleBack = () => {
    history.push("/tickets");
  };*/

  return (
    <>
      {loading ? (
        <TicketHeaderSkeleton />
      ) : (
        <Card square className={classes.ticketHeader}>
          {/* <Button color="primary" onClick={handleBack}>
            <ArrowBackIos />
          </Button> */}
          {children}
        </Card>
      )}
    </>
  );
};

export default TicketHeader;
